<template>
    <div class="user-center">
        <div class="user-box">
            <div class="avatar">
                <van-image
                    round
                    :src="userInfo.avatar"
                    :error-icon="require('@images/noavatar.png')"
                ></van-image>
            </div>
            <div class="center">
                <div class="info" v-if="isLogin">
                    <div class="name">{{ userInfo.nickname }}</div>
                    <div class="id">会员ID:{{ userInfo.uuid }}</div>
                </div>
                <div class="info" v-else>
                    <div class="name" @click="login()">请登陆</div>
                </div>
            </div>
            <div class="right">
                <div class="auth" :class="'auth-' + userInfo.is_auth">
                    {{ userInfo.is_auth ? '已认证' : '未认证' }}
                </div>
            </div>
        </div>
        <div class="menu-wrap">
            <router-link to="/user/profile" class="menu">
                <div class="ico">
                    <img src="@images/user-profile-ico.png" alt="profile" />
                </div>
                <div class="name">个人资料</div>
                <div class="right">
                    <span v-if="userInfo.is_auth == 0">
                        你还没有认证
                        <router-link to="/user/authenticate">立即认证</router-link>
                    </span>
                    <van-icon name="arrow" size="16" />
                </div>
            </router-link>
            <router-link to="/user/classes" class="menu">
                <div class="ico">
                    <img src="@images/user-classes-ico.png" alt="profile" />
                </div>
                <div class="name">参与的课程</div>
                <div class="right"><van-icon name="arrow" size="16" /></div>
            </router-link>
            <router-link to="/user/reserve" class="menu">
                <div class="ico">
                    <img src="@images/user-apply-ico.png" alt="profile" />
                </div>
                <div class="name">我的预约</div>
                <div class="right"><van-icon name="arrow" size="16" /></div>
            </router-link>
        </div>
        <MsgPopup ref="tips"></MsgPopup>
    </div>
</template>
<script>
import { getUserInfo } from '@api/user';
import { mapGetters } from 'vuex';
import toLogin from '@libs/login';
// import dayjs from 'dayjs';, login
import MsgPopup from '@components/MsgPopup';
import cookie from '@utils/store/cookie';
export default {
    name: 'User',
    components: {
        MsgPopup
    },
    data() {
        return {
            userInfo: {
                phone: '',
                avatar: require('@images/noavatar.png'),
                nickname: '',
                uuid: '',
                is_auth: 0
            }
        };
    },
    computed: {
        ...mapGetters(['isLogin'])
    },
    watch: {
        $route(n) {
            if (n.name === 'User') {
                this.getUserData();
            }
        }
    },
    mounted() {
        this.getUserData();
    },
    methods: {
        getUserData() {
            let that = this,
                isShowTips = cookie.get('show-auth-tip');
            if (this.isLogin) {
                getUserInfo(this.id)
                    .then(res => {
                        that.$set(that, 'userInfo', res.data);
                        if (!res.data.is_auth && !isShowTips) {
                            this.$refs.tips.show(
                                3,
                                '',
                                '立即认证，获取报名资格',
                                '去认证',
                                function() {
                                    this.$router.push({ path: '/user/authenticate' });
                                },
                                function() {
                                    cookie.set('show-auth-tip', 1);
                                }
                            );
                        }
                    })
                    .catch(() => {
                        return that.$store.commit('LOGOUT');
                    });
            }
        },
        login() {
            toLogin();
            // login({ openid: 'oa4f3wdnWps4FWDmepIeFngx-FWk' }).then(({ data }) => {
            //     const expires_time = dayjs(data.expires_time);
            //     this.$store.commit('LOGIN', data.token, expires_time);
            //     this.$store.commit('UPDATE_USERINFO', data.member);
            // });
        }
    }
};
</script>
